import BasicCard from '../../../components/basics/cards/BasicCard';


function UploadInformation({ source, lastRunDate, lastRunFile, lastRunUser, lastRunResult, succesFulRunfile, lastSuccesFulDate }) {

    return (
        <BasicCard cardConfig={{ cardTitle: 'Information', cardHeadingElement: 'h5'}}>
            <table className='upload-table'>
                <tbody>
                    <tr>
                        <td><strong>Source</strong></td>
                        <td>{source}</td>
                    </tr>
                    <tr>
                        <td><strong>Last Run</strong></td>
                        <td>{lastRunDate}</td>
                    </tr>
                    <tr>
                        <td><strong>Last Run File</strong></td>
                        <td>{lastRunFile}</td>
                    </tr>


                    <tr>
                        <td><strong>User</strong></td>
                        <td>{lastRunUser }</td>
                    </tr>
                    <tr>
                        <td><strong>Result last run</strong></td>
                        <td>{ lastRunResult}</td>
                    </tr>
                    <tr>
                        <td><strong>Last succesful run file</strong></td>
                        <td>{succesFulRunfile}</td>
                    </tr>
                    <tr>
                        <td><strong>Last succesful date</strong></td>
                        <td>{lastSuccesFulDate}</td>
                    </tr>

                </tbody>
            </table>
        </BasicCard>
    )
};

export default UploadInformation;